// Imports
import React, { useState, useEffect } from "react"
import { Carousel } from "react-responsive-carousel"
import { GatsbyImage, getImage } from "gatsby-plugin-image"

export const useAutoplayCarousel = (autoplayInterval, slides) => {
  const [currentSlide, setCurrentSlide] = useState(0)

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide(currentSlide === slides.length - 1 ? 0 : currentSlide + 1)
    }, autoplayInterval)
    return () => clearInterval(interval)
  }, [autoplayInterval, currentSlide, slides.length])

  return (
    <Carousel
      selectedItem={currentSlide}
      animationHandler="fade"
      showArrows={0}
      showStatus={0}
      showThumbs={0}
      showIndicators={0}
    >
      {slides.map((slide) => {
        const image = getImage(slide.gatsbyImageData)
        return (
          <div key={slide.url}>
            <GatsbyImage
              image={image}
              alt={slide.filename}
              style={{ height: "100vh" }}
            />
          </div>
        )
      })}
    </Carousel>
  )
}
